import { render, staticRenderFns } from "./firstpage.vue?vue&type=template&id=5770f91e&scoped=true"
import script from "./firstpage.vue?vue&type=script&lang=js"
export * from "./firstpage.vue?vue&type=script&lang=js"
import style0 from "./firstpage.vue?vue&type=style&index=0&id=5770f91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5770f91e",
  null
  
)

export default component.exports